import React, { useState, useRef, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import "./CustomTooltip.css";

// Tooltip simples, preto com texto branco, posicionado via Portal
const CustomTooltip = ({ content, children, disabled = false, className = "" }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  const updatePosition = useCallback(() => {
    if (!triggerRef.current) return;

    const triggerRect = triggerRef.current.getBoundingClientRect();
    const tooltipHeight = tooltipRef.current?.offsetHeight || 40;
    const tooltipWidth = tooltipRef.current?.offsetWidth || 100;

    // Posiciona abaixo e centralizado
    let top = triggerRect.bottom + 10;
    let left = triggerRect.left + (triggerRect.width / 2) - (tooltipWidth / 2);

    // Ajusta se sair da tela pela direita
    if (left + tooltipWidth > window.innerWidth - 10) {
      left = window.innerWidth - tooltipWidth - 10;
    }

    // Ajusta se sair da tela pela esquerda
    if (left < 10) {
      left = 10;
    }

    // Ajusta se sair da tela por baixo (posiciona acima)
    if (top + tooltipHeight > window.innerHeight - 10) {
      top = triggerRect.top - tooltipHeight - 10;
    }

    setPosition({ top, left });
  }, []);

  const show = () => {
    if (!disabled) {
      setVisible(true);
      // Atualiza posição após render
      requestAnimationFrame(updatePosition);
    }
  };

  const hide = () => setVisible(false);

  useEffect(() => {
    if (visible) {
      updatePosition();
      window.addEventListener('scroll', updatePosition, true);
      window.addEventListener('resize', updatePosition);

      return () => {
        window.removeEventListener('scroll', updatePosition, true);
        window.removeEventListener('resize', updatePosition);
      };
    }
  }, [visible, updatePosition]);

  return (
    <>
      <div
        ref={triggerRef}
        className={`custom-tooltip ${className}`}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        role="presentation"
      >
        {children}
      </div>
      {!disabled && createPortal(
        <div
          ref={tooltipRef}
          className={`custom-tooltip-bubble-portal ${visible ? "is-visible" : ""}`}
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
          }}
        >
          {content}
          <span className="custom-tooltip-arrow-portal" />
        </div>,
        document.body
      )}
    </>
  );
};

export default CustomTooltip;
